"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LABEL_TYPE = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const enums_1 = require("./enums");
Object.defineProperty(exports, "LABEL_TYPE", { enumerable: true, get: function () { return enums_1.LABEL_TYPE; } });
const Label = ({ theme, inversed, label, customColors, className, custoObjectInfo }) => {
    if (!label && !custoObjectInfo) {
        return null;
    }
    const hasCustomColors = Object.entries(customColors).length > 0;
    let editModal = null;
    if (custoObjectInfo) {
        editModal = () => {
            custoObjectInfo.handler(custoObjectInfo.entryPoint);
        };
        className = `${className} custo-editable`;
    }
    return (react_1.default.createElement("span", { className: (0, classnames_1.default)('label', {
            label_type__PROMO: theme === enums_1.LABEL_TYPE.PROMO && !inversed && !hasCustomColors,
            label_type__PROMO_INVERSE: theme === enums_1.LABEL_TYPE.PROMO && inversed && !hasCustomColors,
            label_type__ACTIVE: theme === enums_1.LABEL_TYPE.ACTIVE && !inversed && !hasCustomColors,
            label_type__ACTIVE_INVERSE: theme === enums_1.LABEL_TYPE.ACTIVE && inversed && !hasCustomColors,
            label_type__INACTIVE: theme === enums_1.LABEL_TYPE.INACTIVE && !inversed && !hasCustomColors,
            label_type__INACTIVE_INVERSE: theme === enums_1.LABEL_TYPE.INACTIVE && inversed && !hasCustomColors,
            label_type__SUCCESS: theme === enums_1.LABEL_TYPE.SUCCESS && !inversed && !hasCustomColors,
            label_type__SUCCESS_INVERSE: theme === enums_1.LABEL_TYPE.SUCCESS && inversed && !hasCustomColors,
            label_type__WARNING: theme === enums_1.LABEL_TYPE.WARNING && !inversed && !hasCustomColors,
            label_type__WARNING_INVERSE: theme === enums_1.LABEL_TYPE.WARNING && inversed && !hasCustomColors,
            label_type__ERROR: theme === enums_1.LABEL_TYPE.ERROR && !inversed && !hasCustomColors,
            label_type__ERROR_INVERSE: theme === 'error' && inversed && !hasCustomColors,
        }, className), style: {
            color: hasCustomColors ? customColors.color : null,
            background: hasCustomColors ? customColors.background : null,
        }, onClick: editModal }, label));
};
Label.propTypes = {
    theme: prop_types_1.default.string,
    label: prop_types_1.default.string.isRequired,
    inversed: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    customColors: prop_types_1.default.shape({
        color: prop_types_1.default.string,
        background: prop_types_1.default.string,
    }),
};
Label.defaultProps = {
    theme: '',
    inversed: false,
    className: '',
    customColors: {},
};
exports.default = Label;
//# sourceMappingURL=index.js.map